// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"240":"booking","353":"contact","546":"therapy","688":"treatments","957":"privacy"}[chunkId] + "." + {"240":"a7077f74","353":"e1e60c8a","546":"6102cd24","688":"9aba7aea","957":"c10f16ff"}[chunkId] + ".js";
};